var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChevronRightTransparent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(-90 0.5 23.5)",
    stroke: "#5D5CF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9311 12L9.24994 8.31886C8.91506 7.98399 8.91506 7.44105 9.24994 7.10618C9.58481 6.7713 10.1277 6.7713 10.4626 7.10618L14.7501 11.3937C15.085 11.7285 15.085 12.2715 14.7501 12.6064L10.4626 16.8939C10.1277 17.2287 9.58481 17.2287 9.24994 16.8939C8.91506 16.559 8.91506 16.0161 9.24994 15.6812L12.9311 12Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronRightTransparent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-right-transparent.a28420db.svg";
export { ForwardRef as ReactComponent };